import React from 'react';
import { Phone } from 'lucide-react';

const CallFloat = () => {
  const phoneNumber = '+919873514657';

  return (
    <a
      href={`tel:${phoneNumber}`}
      className="fixed bottom-6 right-6 z-50 bg-amber-600 hover:bg-amber-700 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 group"
      aria-label="Call us"
    >
      <Phone size={28} className="animate-pulse" />
      <span className="absolute right-full mr-3 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Call: +91 98735 14657
      </span>
    </a>
  );
};

export default CallFloat;
